import { render, staticRenderFns } from "./DisplayArrayField.vue?vue&type=template&id=5be09594&scoped=true&"
import script from "./DisplayArrayField.vue?vue&type=script&lang=js&"
export * from "./DisplayArrayField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be09594",
  null
  
)

export default component.exports